import {useContentContext} from "../utils/ContentProvider"

const RemoteSales = () => {
  const {translations} = useContentContext()

  return (
    <div className="bg-white px-6 py-32 lg:px-8">
      <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Etämyynnin
          ennakkotiedot</h1>
        <p className="mt-6">Etämyynnillä tarkoitetaan vakuutuksen tekemistä verkon, puhelimen, postin tai muun
          etävälineen avulla ilman vakuutuksenottajan ja vakuutusyhtiön edustajan henkilökohtaista tapaamista.</p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Vakuutuksenantaja</h2>
        <p className="mt-6">
          Vakuutuksenantajana on asiakkaan palvelussa valitsema vakuutusyhtiö. Asiakkaan valitseman vakuutusyhtiön
          yhteystiedot näkyvät vakuutusehdotuksessa. Asiakas voi samassa yhteydessä tutustua vakuutusyhtiön
          tuote-esitteeseen sekä yksityiskohtaisiin sopimusehtoihin.
        </p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Vakuutusasiamies</h2>
        <p className="mt-6">
          Little Buck Oy on eri vakuutusyhtiötä edustava vertailupalvelu, joka auttaa asiakkaitaan löytämään heidän
          tarpeitaan vastaavan vakuutustarjouksen. Little Buck Oy vastaa Vakuutuslaskuri.fi-palvelun toiminnasta.
        </p>
        <p className="mt-6">
          Little Buck Oy<br/>
          Maariankatu 1 B 44, 20100 Turku<br/>
          Sähköposti <a href="mailto:info@vakuutuslaskuri.fi" className="underline">info@vakuutuslaskuri.fi</a><br/>
          Internet <a href="http://www.vakuutuslaskuri.fi" target="_blank" className="underline">
          http://www.vakuutuslaskuri.fi</a><br/>
          Y-tunnus 285439-2
        </p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Julkiset rekisterit</h2>
        <p className="mt-6">
          Little Buck Oy on merkitty seuraaviin patentti- ja rekisterihallituksen ja verohallinnon yhteisen
          yritystietojärjestelmän <a href="http://www.ytj.fi" target="_blank" className="underline">
          http://www.ytj.fi</a> julkisiin rekistereihin:<br/>
          <br/>
          - Kaupparekisteri<br/>
          - Verohallinto<br/>
          - Ennakkoperintärekisteri<br/>
          - Arvonlisäverovelvollisuus ostajana tai omasta käytöstä arvonlisäverovelvollinen
        </p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Valvontaviranomainen</h2>
        <p className="mt-6">
          Little Buck Oy:n valvontaviranomainen on Finanssivalvonta<br/>
          Snellmanninkatu 6 ja Mikonkatu 8<br/>
          PL 103<br/>
          00101 Helsinki<br/>
          Puh. <a href="tel:01083151" target="_blank" className="underline">010 831 51</a><br/>
          <a href="https://www.finanssivalvonta.fi" target="_blank"
             className="underline">www.finanssivalvonta.fi</a>
        </p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Tuotteiden pääominaisuudet
        </h2>
        <p className="mt-6">
          Vakuutuksen laajuutta ja sen keskeisiä rajoituksia koskevat tiedot sekä etämyynnin tuotekohtaiset
          ennakkotiedot löytyvät kunkin vakuutusyhtiön vakuutuksen tuote-esitteestä ja vakuutusehdoista.
        </p>
        <p className="mt-6">Vakuutuksen hintoihin ja maksamiseen liittyvät tiedot näkyvät yhtiöittäin ja
          tuotteittain palvelun vakuutusehdotuksessa.</p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Peruuttamisoikeus</h2>
        <p className="mt-6">Kuluttajasuojalain peruuttamisoikeutta koskevia säännöksiä ei sovelleta
          vakuutussopimuksiin, vaan niihin sovelletaan vakuutussopimuslain säännöksiä. Vakuutussopimuslain mukaan
          vakuutus on irtisanottava kirjallisesti. Irtisanotusta vakuutuksesta peritään vakuutusmaksu sen
          voimassaolon ajalta. Määräaikaisissa vakuutuksissa, joiden kesto on alle 30 vuorokautta, ei ole
          irtisanomisoikeutta.</p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Tiedot oikeusturvakeinoista</h2>
        <p className="mt-6">Tietoa asiakkaan käytettävissä olevista oikeussuojakeinoista saa kunkin vakuutusyhtiön
          yleisistä sopimusehdoista.</p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Muita tietoja</h2>
        <p className="mt-6">
          Vakuutussopimuksiin sovelletaan Suomessa voimassa olevaa lainsäädäntöä.<br/><br/>
          Little Buck Oy:n palvelukieli etämyynnissä on suomi.<br/><br/>
          Hakemus voidaan vahvistaa verkossa asiakkaan pankin tarjoamalla e-tunnistepalvelua käyttäen.
          Vakuutusyhtiön vastuun alkamisesta ja vakuutussopimuksen ajallista voimassaoloa koskevat tiedot löytyvät
          vakuutusyhtiöittäin ja tuotteittain eritellysti
        </p>
      </div>
    </div>
  )
}

export default RemoteSales
